/**
 * Channel colours on buyer Call Logs, by rank: the channel with the most calls in the window always gets the first
 * colour, the second busiest the second, and so on. Muted so a page full of channels stays calm on the dark theme.
 * Channels past the palette, and channels the ranking does not know, are neutral grey.
 */
export const CHANNEL_COLORS = Object.freeze([
  '#5b8def', // blue
  '#9b7be0', // purple
  '#4fb59a', // teal
  '#d9a14e', // amber
  '#d9708f', // rose
  '#5fb3c9', // cyan
  '#a3b65a', // olive
  '#c97f5b' // terracotta
])

export const OTHER_CHANNEL_COLOR = '#8a94a6'

/**
 * @param {Array<{ channel: string, callCount: number }>} channels per-channel call counts in the window
 * @returns {Object<string, string>} colour by channel name
 */
export function rankChannelColors(channels) {
  const ranked = [...(channels || [])]
    .filter(row => row && row.channel)
    .sort((a, b) => (b.callCount || 0) - (a.callCount || 0) || a.channel.localeCompare(b.channel))

  return ranked.reduce((colors, row, index) => {
    colors[row.channel] = index < CHANNEL_COLORS.length ? CHANNEL_COLORS[index] : OTHER_CHANNEL_COLOR

    return colors
  }, {})
}

function rgba(hex, alpha) {
  const value = parseInt(hex.slice(1), 16)

  return `rgba(${(value >> 16) & 255}, ${(value >> 8) & 255}, ${value & 255}, ${alpha})`
}

// Inline style for a channel pill: the colour as text, a faint fill and a half-strength border
export function channelPillStyle(color) {
  const base = color || OTHER_CHANNEL_COLOR

  return {
    color: base,
    backgroundColor: rgba(base, 0.14),
    borderColor: rgba(base, 0.55)
  }
}
